export default __webpack_public_path__ + "static/media/Wristwraps of the Forsaken.5a23d062.jpg";